module.exports = __webpack_public_path__ + "static/boost-6f444ca920083b753097c8387e28e236.svg";